import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import {msalConfig} from "./authConfig";


// Create MSAL instance only once, even with HMR and StrictMode. Add commentfor testing.
// Store instance in window to persist across HMR reloads
const getMsalInstance = () => {
  const instanceKey = `msalInstance_${msalConfig.auth.clientId}`;
  
  if (!window[instanceKey]) {
    window[instanceKey] = new PublicClientApplication(msalConfig);
    // Initialize MSAL instance
    window[instanceKey].initialize().then(() => {
      // MSAL initialized successfully
    }).catch((error) => {
      console.error('MSAL initialization error:', error);
    });
  }
  
  return window[instanceKey];
};

const msalInstance = getMsalInstance();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <App />
        </MsalProvider>
    </React.StrictMode>
);